import { useEffect, useState } from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import Leadcard from "../../Subcomponents/Leadcard";
import { getLeadsBySalesManager } from "../../Services/SmartFloApis";
import SmartfloLeadCard from "./SmartfloLeadCard";

export default function LeadsView({ salesManagerId, onBack, smName }) {
  const [leads, setLeads] = useState([]);
console.log("🔥 SM NAME:", smName);
  // 🔥 FETCH ALL LEADS (NO TAB FILTER)
 const fetchLeads = async () => {
  try {
    const res = await getLeadsBySalesManager(salesManagerId);

    if (res.success) {

      // 🔥 FULL RAW DATA LOG
      console.log("🚀 FULL API DATA:", res.data);

      let data = res.data.map((el, index) => {
        const person = el?.Person || {};

        // 🔍 DEBUG EACH RECORD
        console.log(`🔎 Lead ${index}`, {
          full: el,
          projectName: el?.projectName,
          Project: el?.Project,
          project: el?.project,
          Inventory: el?.Inventory,
          unitType: el?.unitType,
        });

       return {
  ...el,

  id: el?.leadId,

  createdAt: el?.created_at
    ? new Date(Number(el.created_at))
    : new Date(),

  person: {
    name: person.name || "-",
    contactNumber: person.contactNumber || "-",
  },

  status: el?.leadStatus || "Unclaimed",
  leadStatus: el?.leadPriority || "WARM",

  type: el?.leadType || "-",

  Sales: {
    name: el?.Sales?.name || "-",
  },

  CP: {
    name: el?.CP?.name || "NA",
  },

  FOS: {
    name: el?.FOS?.name || "NA",
  },

  // ✅ FIXED PROJECT DATA
  project: {
    name: el?.Inventory?.[0]?.Projects?.projectName || "-",
    unitType: el?.Inventory?.[0]?.displayUnitType || "-",
    unitNo: el?.Inventory?.[0]?.unitNo || "-",
  },

  leadDetails: {
    contactNumber: person.contactNumber || "-",
  },
};
      });

      console.log("✅ FINAL MAPPED DATA:", data);

      setLeads(data);
    }
  } catch (err) {
    console.error("❌ Error fetching leads:", err);
  }
};

  // 🔥 INITIAL LOAD
  useEffect(() => {
    if (salesManagerId) {
      fetchLeads();
    }
  }, [salesManagerId]);

  return (
    <Box>

      {/* 🔙 Back */}
      <Typography
        onClick={onBack}
        sx={{ cursor: "pointer", mb: 2 }}
      >
        ← Back
      </Typography>

      {/* 🔥 Header */}
      {/* Mirrors the Leads record-count header (.leadsCount in
          Leads.module.css): same values, deliberately WITHOUT !important so the
          global rule in App.css:198-202 overrides font-family, font-size and
          line-height exactly as it does for Leads. font-weight and color are
          not set by that rule, so they apply and match Leads. */}
      <Typography
        sx={{
          fontFamily: "Inter-Medium",
          fontStyle: "normal",
          fontWeight: 500,
          fontSize: "1.8rem",
          lineHeight: "2.8rem",
          color: "#101828",
        }}
      >
        Leads for {smName || "Sales Manager"} ({leads.length})
      </Typography>

      {/* 🔥 LEAD CARDS */}

      {leads.length > 0 ? (
        leads.map((lead, index) => (
          <Box sx={{ mt: 2 }}>
          <SmartfloLeadCard
            key={index}
            leadObj={lead}
            claimLead={() => {}}
           
          />
          </Box>
        ))
      ) : (
        <Typography sx={{ mt: 3 }}>
          No Leads Found
        </Typography>
      )}

    </Box>
  );
}